// src/components/TabButton.js
import React from 'react';

const TabButton = ({ selectTab, active, children }) => {
  return (
    <button
      onClick={selectTab}
      className={`px-4 py-2 rounded-lg ${active ? 'bg-primary-500 text-white' : 'bg-gray-200 text-gray-800'}`}
    >
      {children}
    </button>
  );
};

export default TabButton;
